/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RouteDtoModel, RouteDtoModelType } from "./RouteDtoModel"
import { RouteDtoModelSelector } from "./RouteDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  route: RouteDtoModelType;
}

/**
 * RouteOptimizedDtoBase
 * auto generated base class for the model RouteOptimizedDtoModel.
 */
export const RouteOptimizedDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('RouteOptimizedDto')
  .props({
    __typename: types.optional(types.literal("RouteOptimizedDto"), "RouteOptimizedDto"),
    route: types.union(types.undefined, MSTGQLRef(types.late((): any => RouteDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class RouteOptimizedDtoModelSelector extends QueryBuilder {
  route(builder: string | RouteDtoModelSelector | ((selector: RouteDtoModelSelector) => RouteDtoModelSelector) | undefined) { return this.__child(`route`, RouteDtoModelSelector, builder) }
}
export function selectFromRouteOptimizedDto() {
  return new RouteOptimizedDtoModelSelector()
}

export const routeOptimizedDtoModelPrimitives = selectFromRouteOptimizedDto()
